module.exports = __webpack_public_path__ + "assets/img/Earlytrade-Website-w960.de4ff7b3.webp";